<template>
  <div class="selector-grid__wrapper">
    <div class="selector-grid__item selector-grid__item--texture"
         :class="selectedTexture && selectedTexture.img_id === item.img_id  ? 'selected' : ''"
         v-for="(item,i) in items"
         :key="item.img_id"
         @click="setTexture(item,i)">
      <div class="selector-grid__image-container selector-grid__image-container--texture" :style="{backgroundImage: `url(${item.thumbnail || item.src})`}" alt=""></div>
      <h4 class="selector-grid__title selector-grid__title--texture">{{ item.title }}</h4>
    </div>
  </div>
</template>

<script>
  // import * as THREE from 'three';

  import { mapActions, mapMutations, mapGetters } from 'vuex';
  import * as mutationTypes from '../../store/mutation-types'

  export default {
    name: "TextureCarousel",
    props: {
      items: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        itemsPerSlide: 3,
        vilibleSlide: 3,
      }
    },
    computed: {
      ...mapGetters('clothes',[
        'selectedMesh',
      ]),
      ...mapGetters('textures',[
        'selectedTexture',
      ]),
      arrowsOutside: function() {
        return this.items.length > this.vilibleSlide;
      },
    },
    watch: {
      selectedMesh: function() {
        // if(this.selectedMesh.id && this.selectedMesh.userData.texture) {
        //   // this[mutationTypes.SET_SELECTED_TEXTURE](this.selectedMesh.userData.texture);
        //   // this.goToSlide(this.selectedMesh.userData.texture);
        // } else {
        //   // this.goToSlide({});
        // }
      }
    },
    methods: {
      ...mapActions('textures',[
        'uploadTexture',
        'setSelectedTexture'
      ]),
      ...mapActions([
        'render'
      ]),
      ...mapMutations('textures',[
        mutationTypes.SET_SELECTED_TEXTURE,
      ]),
      resetTexture() {

      },
      setTexture(item) {
        this.setSelectedTexture(item).then(() => {

          // let color = new THREE.Color(0.9,0.9,0.9);
          //
          // if(this.selectedMesh.userData.backMesh) {
          //   this.selectedMesh.userData.backMesh.material.color = color;
          //   this.selectedMesh.userData.backMesh.material.map = payload.inst;
          //   this.selectedMesh.userData.backMesh.material.needsUpdate = true;
          // }
          // this.selectedMesh.material.color = color;
          // this.selectedMesh.material.map = payload.inst;
          // this.selectedMesh.material.needsUpdate = true;
          this.render();
        });
      },
      goToSlide(texture) {
        let i = this.items.indexOf(texture) + 1;
        this.$refs.slider && this.$refs.slider.goToSlide(i);
      }
    },
    mounted() {
      // console.log(this.items);
      // this.vilibleSlide = this.items.length > this.itemsPerSlide ? this.itemsPerSlide : this.items.length;
      // if(this.selectedMesh.id && this.selectedMesh.userData.texture) {
      //   this[mutationTypes.SET_SELECTED_TEXTURE](this.selectedMesh.userData.texture);
      //   this.goToSlide(this.selectedMesh.userData.texture);
      // }
    }
  }
</script>

<style scoped>
  .selector-grid__item--texture {
    width: 45%;
  }

  .selector-grid__image-container--texture {
    padding-top: 61%;

  }

</style>